<template>
  <div>
    <div class="showsample">
      <div class="showsample__btn"　@click="openSample()">
        <div class="text_wrap">
          <span class="text">サンプル全文を見る</span>
        </div>
      </div>
    </div>

    <app-modal title="占いサンプル" :active="isShowModal" @close="isShowModal=false" :location-path="ga_location">
      <div slot="header">
        <span>この画面は占いのサンプルです</span>
      </div>
      <div slot="itemdetail">
        <!-- タイトル -->
        <div class="contentTitleBar">
          <div class="contentTitleBar__tagarea">
            <span class="badge">{{ item.service_type_str }}</span>
            <span :class="'badge u-tag-'+item.category_tag_id">{{ item.category_tag_name }}</span>
          </div>
          <p class="title_text">
            {{ item.item_name }}
          </p>
        </div>

        <!-- 画像 -->
        <div class="contentImgArea__bg u-mg-center">
          <uranai-img data-clip-path-support="true" data-size="bg" size="bg" :src="item.pack_image" :alt="item.item_name"></uranai-img>
        </div>
        <div class="contentAdviser">
          <div class="contentAdviser__description">{{ item.detailed_explanation}}</div>
          <hr class="contentSeparatorSection u-mg-t-2">
        </div>
      </div>
      <div slot="content" class="modal__body__input special">
        <div class="storyResult">
          <app-loading :isLoading="sampleText.length > 0 ? false : true" class="u-mg-center u-mg-t-3"></app-loading>
          <div v-html="sampleText" class="resultContent__special">
          </div>
        </div>

        <!-- 占い師 -->
        <div class="u-width-10" v-if="counselorId">
          <hr class="contentSeparatorSection u-mg-t-4 u-mg-b-4">
          <modern-counselor-card :counselor-id="counselorId" class="u-mg-t-4 u-mg-b-4"></modern-counselor-card>
        </div>
      </div>
    </app-modal>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
var initialLocation = location.origin + location.pathname

export default {
  name: 'show-sample',
  props: {
    itemsId: [Number, String],
    counselorId: [Number, String],
  },
  data() {
    return {
      sampleText: '',
      isShowModal: false,
      ga_location: initialLocation
    }
  },
  computed: {
    ...mapState({
      item: state => state.item.selected,
      counselor: state => state.counselors.counselor
    })
  },
  mounted(){
    this.$store.dispatch(type.SELECT_ITEM, { id: parseInt(this.itemsId, 10) })
    this.$store.dispatch(type.RESET_COUNSELOR)
    if(this.counselorId){
      this.$store.dispatch(type.GET_COUNSELOR,this.counselorId)
    }
  },
  methods: {
    clickOpen() {
      const listitem = this.$refs.listItem
      Object.keys(listitem).forEach(function(elm){
        listitem[elm].style.display = 'block';
      })
      this.$refs.btnshowmoreMovie.style.display = 'none';
    },
    openSample(){
      // GA送信
      window.gtag('event', 'SampleText', {
        page_location: initialLocation + '/sample'
      })

      this.isShowModal = true;
      this.getSampleText(this.itemsId)
    },
    getSampleText(id) {
      if(this.sampleText!=null){
        return axios.post('/api/items/getsampletext', { items_id: parseInt(this.itemsId, 10) })
        .then(response => {
          if (response.status === 200 && response.data.response === 'OK') {
            this.sampleText = response.data.sample_text

          } else {
            this.sampleText = 'サンプルが存在しません'
            return Promise.reject()
          }
          
        })
      }
    },

  }
}
</script>

<style lang="scss">
.showsample {
  text-align: right;

  &__btn {
    cursor: pointer;
    position: relative;
    color: #ed1e79;
    width: 160px;
    margin: auto;
    display: block;
    font-size: 12px;
    line-height: 22px;
    min-width: 161px;
    text-align: center;

    .text_wrap {

    }

    .text {
      &:after {
        content: '';
        width: 22px;
        height: 22px;
        position: absolute;
        background: url('/static/img/common/arrow_right_pink.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ShowSample.vue